import { render, staticRenderFns } from "./menuData.pug?vue&type=template&id=fe2f0156&lang=pug&"
import script from "./menuData.ts?vue&type=script&lang=ts&"
export * from "./menuData.ts?vue&type=script&lang=ts&"
import style0 from "./menuData.styl?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports